import { RadioCard, HStack, Text } from "@chakra-ui/react";

import { ProductDetails } from "helpers/fakeData";
import { useCallback, useLayoutEffect } from "react";

interface Props {
  product: ProductDetails;
  onSelectColor: (color: string) => void;
}

const ColorPicker = ({ product, onSelectColor }: Props) => {
  const colors = product.colors ?? [];
  const defaultColor = colors.length > 0 ? colors[0] : undefined;

  const handleSelectColor = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onSelectColor(e.target.value);
    },
    [onSelectColor]
  );

  useLayoutEffect(() => {
    if (defaultColor != null) {
      onSelectColor(defaultColor);
    }
  }, []);

  if (colors.length === 0) {
    return null;
  }

  return (
    <RadioCard.Root
      orientation="horizontal"
      align="center"
      justify="center"
      maxW="lg"
      defaultValue={colors[0]}
      onChange={handleSelectColor}
    >
      <RadioCard.Label>Color</RadioCard.Label>
      <HStack align="stretch">
        {colors.map((color) => (
          <RadioCard.Item key={color} value={color} cursor="pointer">
            <RadioCard.ItemHiddenInput />
            <RadioCard.ItemControl>
              <Text>{color}</Text>
            </RadioCard.ItemControl>
          </RadioCard.Item>
        ))}
      </HStack>
    </RadioCard.Root>
  );
};

export default ColorPicker;
